import { render, staticRenderFns } from "./content-empty.vue?vue&type=template&id=6fc18f52"
import script from "./content-empty.vue?vue&type=script&lang=js"
export * from "./content-empty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports